<template>
	<v-sheet flat color="transparent" class="pa-4 mb-5">
			<h1 class="cn-font grey--text mb-5">Vorteile zusammengefasst</h1>		
			<v-row v-for="(row, i) in rows" :key="i">
				<v-col cols="12" sm="6">
					<v-img class="d-none d-sm-block" v-if="row.left" :src="row.img" contain/>
					
					<IconPoints v-else v-bind="row"></IconPoints>
				</v-col>
				<v-col  cols="12" sm="6">
					<IconPoints v-if="row.left" v-bind="row">

					</IconPoints>
					<v-img class="d-none d-sm-block" v-else :src="row.img" contain/>
				</v-col>
			</v-row>		

	</v-sheet>
</template>
<script>
	import IconPoints from "@/components/elements/IconPoints"
	export default {
		name: "Process", 
		components: {
			IconPoints
		},
		data: () =>  {
			return {
				rows: [
					{
						img: "https://checkit-now.de/wp-content/uploads/2020/08/gunter-valda-8WGHcMEAa2k-unsplash-scaled.jpg",
						title: "Zügige Auswertung",
						points: [
							{
								icon: "mdi-timer",
								text: "zeitnahe Auswertung durch dynamische Algorithmen"
							},
							{
								icon: "mdi-chart-bar", 
								text: "barrierefreier Wechsel von bereits genutzten Erhebungstools durch Anwendung bewährter Methodik und UI"
							}
						]

					},
					{
						img: "https://checkit-now.de/wp-content/uploads/2020/08/national-cancer-institute-NFvdKIhxYlU-unsplash-scaled.jpg",
						title: "Präzise Reifegradermittlung",
						left: true,
						text: "CHECK IT NOW ermittelt präzise die digitale Reife Ihres Krankenhauses und identifiziert zukünftige Handlungsfelder",
						points: [
							{
								icon: "mdi-compass",
								text: "tangible und konzise Entscheidungsgrundlage für die digitale Transformation von Prozessen"
							},
							{
								icon: "mdi-office-building", 
								text: "validiertes Assessment Ihres Krankenhauses als Grundlage für eine erfolgreiche Fördermittelzuweisung"
							}
						]

					},
					{
						img: "https://checkit-now.de/wp-content/uploads/2020/08/adeolu-eletu-unRkg2jH1j0-unsplash-scaled.jpg",
						title: "Starker Nutzerfokus",
						text: "CHECK IT NOW bindet in allen Schritten die Anwenderinnen und Anwender ein",
						points: [
							{
								icon: "mdi-thumb-up",
								text: "hohe Akzeptanz in allen Stakeholdergruppen durch klaren Nutzerfokus"
							},
							{
								icon: "mdi-laptop", 
								text: "prozessorientierte Betrachtung von Digitalisierungspotenzialen entlang der vollständigen Versorgungskette"
							}
						]

					},
					{
						img: "https://checkit-now.de/wp-content/uploads/2020/08/javier-matheu-AHDeiqdiC7Q-unsplash-scaled.jpg",
						title: "Hohe Flexibilität",
						text: "CHECK IT NOW ist dynamisch für jede Gesundheitseinrichtung adaptierbar",
						left: 1,
						points: [
							{
								icon: "mdi-arrow-expand",
								text: "hohe Vergleichbarkeit von Krankenhäusern (z. B. innerhalb eines Verbundes, im nationalen Wettbewerb)"
							},
							{
								icon: "mdi-database", 
								text: "neutrale Datenbasis für die effiziente Digitalisierung Ihres Krankenhauses"
							}
						]

					}
				]
			}
		}
	}
</script>